<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-form
            ref="workReportForm"
        >
          <h3 class="mb-3">{{ $vuetify.lang.t('$vuetify.work_report.title') }}</h3>
          <v-textarea
              v-model="work_report_input"
              counter
              :maxlength="maxLength"
              no-resize
              rows="6"
              ref="inputRef"
              :label="$vuetify.lang.t('$vuetify.work_report.placeholder')"
              autofocus
              :disabled="formDisabled"
          ></v-textarea>
          <div class="text-center text-md-left">
            <v-btn v-if="user_can_skip_report" class="white--text mb-4" color="red" @click="doLocationCheck">
              {{ $vuetify.lang.t('$vuetify.work_report.skip_work_report') }}
            </v-btn>
            <v-spacer/>
            <v-btn class="white--text" color="primary" :disabled="isFilled" @click="doLocationCheck">
              {{ $vuetify.lang.t('$vuetify.global.confirmAndSend') }}
            </v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
    <locationPopup :is-visible="showPrivateLocationPopup" @checkComplete="save"></locationPopup>
  </v-container>
</template>

<script>
import {mobileCheckMixin} from "../../../mixins/MobileCheckMixin/MobileCheckMixin";
import appSettings from "../../../mixins/config/appSettings";
import PrivateLocationCheckComponent from '../global/privateLocationChecker/PrivateLocationCheckComponent';
import urlParamsConstructor from '../../../mixins/config/urlParamsConstructor';
import workSessionMixin from "@/workSessions/mixins/workSessionMixin";
import {ENTRY_DATA_KEY, LMRADataObjectHelper, WORK_STATE_STOP} from "@/api/repository/helpers/LMRADataObjectHelper";
import lmraDataRepositoryApi from "@/api/repository/lmraDataRepositoryApi";
import sendingLmraDataHelper from "@/helpers/sendingLmraDataHelper";

export default {
  name: "WorkReportComponent",
  mixins: [mobileCheckMixin, urlParamsConstructor, workSessionMixin],
  data: () => {
    return {
      formDisabled: false,
      work_report_input: '',
      minLength: 4,
      maxLength: 800,
      user_can_skip_report: false,
      showPrivateLocationPopup: false,
    }
  },
  components: {
    locationPopup: PrivateLocationCheckComponent
  },
  methods: {
    doLocationCheck() {
      this.showPrivateLocationPopup = true;
    },
    async save() {
      this.showPrivateLocationPopup = false;
      this.formDisabled = true;
      let dataObject = await LMRADataObjectHelper.buildBaseLmraDataObject();
      dataObject[ENTRY_DATA_KEY]['summary'] = this.work_report_input.trim();
      dataObject[ENTRY_DATA_KEY]['work_state'] = WORK_STATE_STOP;

      /* START SENDING PART (DIFFERENT THAN OTHERS!!) */


      await lmraDataRepositoryApi.sendWorkReport(dataObject).then(
          response => {
            let message = this.$vuetify.lang.t('$vuetify.global.post_success');
            if (response.data.message !== undefined) {
              message = response.data.message;
            }

            this.clearWorkSession();
            sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(message);
            this.$router.replace('/');

            //RELEASE THE SESSION LOCK!
          })
          .catch(err => {
            sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(this.$vuetify.lang.t('$vuetify.errors.data_save_failed') + ' err: ' + err.message);
            this.formDisabled = false;
          });
      /* END SENDING PART */
    },
    clearWorkSession() {
      //TODO EXTRA VALIDATION?? OR CHECKS?
      this.$store.dispatch('clearSavedSessionData');
    }
  },
  computed: {
    isFilled: function () {
      let trimmed = this.work_report_input.trim();
      if (trimmed.length >= this.minLength && !this.formDisabled && this.work_report_input.length <= this.maxLength) {
        return false;
      } else {
        return true
      }
    }
  },
  created() {
    this.user_can_skip_report = appSettings.data().appSettings.userCanSkipWorkReport;
  },
  beforeDestroy: function () {
    window.console.log('BEFORE DESTROY');
    if (!this.sessionExpired) {
      window.console.log('SESSION IS NOT EXPIRED YET');
      this.$workSessions.forceCloseWorkSession = false;
    }
  }
}
</script>

<style scoped>

</style>